/* Calacas · ¿Cuál es mi talla? · generado 2026-10-29 desde talla-ideal/ (reglas + fotos + ventana). No editar aquí. */
/* Reglas de «¿Cuál es mi talla?» de Calacas (Juan, 29/10/2026). Puras: se prueban en Node.
   - 1.60 m y ~50 kg → S en clásico y en oversize (la más chica).
   - Oversize S sirve hasta ~1.65 m y 62–65 kg.
   - XL para 1.80–1.90 m o más, hasta 100 kg.
   Medidas reales de la tabla (cm, prenda plana): largo × ancho × manga. */
(function (root) {
  'use strict';

  var MEDIDAS = {
    clasico: { S: [69, 50, 16], M: [72, 53, 17], L: [75, 56, 18], XL: [78, 59, 19] },
    oversize: { S: [72, 56, 19], M: [75, 58, 20], L: [78, 60, 21], XL: [81, 62, 22] },
  };
  MEDIDAS.polera = MEDIDAS.oversize; // la polera calza como el oversize (sin tabla propia todavía)

  // Hasta qué altura (cm) y peso (kg) va cada talla. La talla final es la MAYOR de las dos.
  var TOPES = {
    clasico: [['S', 164, 58], ['M', 171, 68], ['L', 179, 80], ['XL', 999, 100]],
    oversize: [['S', 165, 64], ['M', 173, 75], ['L', 180, 86], ['XL', 999, 100]],
  };
  TOPES.polera = TOPES.oversize;
  var ORDEN = ['S', 'M', 'L', 'XL'];

  function indice(lista, valor, col) {
    for (var i = 0; i < lista.length; i++) if (valor <= lista[i][col]) return i;
    return lista.length - 1;
  }

  /** { talla, porAltura, porPeso, holgura, aviso } para un corte («clasico», «oversize» o «polera»). */
  function recomendar(corte, alturaCm, pesoKg) {
    var t = TOPES[corte] || TOPES.clasico;
    var h = Math.round(Number(alturaCm) || 0), w = Math.round(Number(pesoKg) || 0);
    var ia = indice(t, h, 1), ip = indice(t, w, 2);
    var talla = ORDEN[Math.max(ia, ip)];
    var aviso = '';
    if (w > 100) aviso = 'Más de 100 kg: la XL puede quedarte ajustada. Escríbenos y te asesoramos.';
    else if (h > 192) aviso = 'Más de 1.92 m: la XL puede quedarte corta de largo.';
    return { talla: talla, porAltura: ORDEN[ia], porPeso: ORDEN[ip], holgura: holgura(corte, talla, h, w), aviso: aviso };
  }

  /** Contorno de pecho estimado (cm) a partir de altura y peso (índice de masa corporal). */
  function pechoEstimado(alturaCm, pesoKg) {
    var m = (Number(alturaCm) || 170) / 100;
    var imc = (Number(pesoKg) || 65) / (m * m);
    return Math.max(78, Math.min(130, 52 + 2 * imc));
  }

  /** Cuánto le sobra a la prenda en el pecho (cm de ancho plano) y cómo se siente. */
  function holgura(corte, talla, alturaCm, pesoKg) {
    var med = (MEDIDAS[corte] || MEDIDAS.clasico)[talla];
    var cm = +(med[1] - pechoEstimado(alturaCm, pesoKg) / 2).toFixed(1);
    var como = cm < 1.5 ? 'Ajustado' : cm < 6 ? 'Entallado' : cm < 11 ? 'Suelto' : 'Muy suelto';
    return { cm: cm, como: como };
  }

  var api = { MEDIDAS: MEDIDAS, TOPES: TOPES, ORDEN: ORDEN, recomendar: recomendar, pechoEstimado: pechoEstimado, holgura: holgura };
  root.CalacasTalla = api;
  if (typeof module !== 'undefined' && module.exports) module.exports = api;
})(typeof window !== 'undefined' ? window : globalThis);

/* Calacas · «¿Cuál es mi talla?» · escena con fotos reales.
   12 fotos de la misma persona: 4 contexturas (según el IMC) × 3 prendas (clásico, oversize, polera).
   La foto cambia con un fundido suave; la persona crece o se achica un poco con la altura (regla al costado)
   y la escena se inclina apenas con el cursor (sensación de profundidad). Misma interfaz que la escena 3D. */
(function () {
  'use strict';

  var BASE = 'https://cdn.shopify.com/s/files/1/0648/5760/4161/files/';
  var CUERPOS = [            // [nombre, IMC hasta]
    ['delgado', 19.5], ['normal', 25], ['robusto', 29], ['grande', Infinity],
  ];
  var PRENDA = { clasico: 'clasico', oversize: 'oversize', polera: 'polera' };
  var ALTO_REF = 172;        // la foto «normal» es de alguien de ~1.72 m
  var ESCALA = 0.0045;       // cuánto crece la persona por cm de diferencia (sutil: la foto no deja de verse real)

  function cuerpoDe(h, w) {
    var imc = w / Math.pow(h / 100, 2);
    for (var i = 0; i < CUERPOS.length; i++) if (imc < CUERPOS[i][1]) return CUERPOS[i][0];
    return 'grande';
  }
  // delgado, robusto y grande se rehicieron con el cuerpo más marcado (-v2); normal es la foto base
  var VERSION = { delgado: '-v2', robusto: '-v2', grande: '-v2', normal: '' };
  function url(cuerpo, prenda, ancho) { return BASE + 'talla-' + cuerpo + '-' + prenda + VERSION[cuerpo] + '.jpg?width=' + ancho; }

  function montar(T, escena, op) {
    var menosMov = !!op.menosMov;
    // la foto original es de 896×1200: en celular basta 640 de ancho (≈45 KB), en pantallas grandes la entera
    var ancho = Math.min(window.innerWidth, window.innerHeight) < 700 ? 640 : 896;
    var marco = document.createElement('div'); marco.className = 'cti__foto';
    var persona = document.createElement('div'); persona.className = 'cti__persona';
    var capas = [new Image(), new Image()];
    capas.forEach(function (im) { im.alt = ''; im.decoding = 'async'; im.draggable = false; persona.appendChild(im); });
    marco.appendChild(persona);
    var regla = document.createElement('div'); regla.className = 'cti__metro'; regla.setAttribute('aria-hidden', 'true');
    regla.innerHTML = '<i></i><i></i><i></i><i></i><i></i><i></i><i></i><b data-cti-metro></b>';
    marco.appendChild(regla);
    var nota = document.createElement('span'); nota.className = 'cti__referencial'; nota.textContent = 'Foto referencial'; marco.appendChild(nota);
    escena.insertBefore(marco, escena.firstChild);

    var actual = '', frente = 0, cargadas = {}, activo = true;
    function precargar(lista) { lista.forEach(function (u) { if (cargadas[u]) return; var im = new Image(); im.decoding = 'async'; im.src = u; cargadas[u] = im; }); }

    function mostrar(u) {
      if (u === actual) return;
      actual = u;
      var nueva = capas[1 - frente], vieja = capas[frente];
      var listo = function () {
        if (actual !== u) return; // ya se pidió otra
        nueva.classList.add('is-on'); vieja.classList.remove('is-on');
        frente = 1 - frente;
        escena.classList.add('listo');
      };
      nueva.onload = listo;
      nueva.onerror = function () { escena.classList.add('sin-3d'); };
      nueva.src = u;
      if (nueva.complete && nueva.naturalWidth) listo();
    }

    // altura: la persona crece desde los pies; el metro marca la altura elegida
    var metro = regla.querySelector('[data-cti-metro]');
    function altura(h) {
      var s = 1 + (h - ALTO_REF) * ESCALA;
      persona.style.setProperty('--s', s.toFixed(3));
      var p = Math.max(0, Math.min(1, (h - 140) / 60));
      regla.style.setProperty('--p', p.toFixed(3));
      metro.textContent = (h / 100).toFixed(2) + ' m';
    }

    // profundidad: la foto se inclina un poco con el cursor (no en celular ni con «reducir movimiento»)
    if (!menosMov && window.matchMedia && window.matchMedia('(hover: hover)').matches) {
      escena.addEventListener('pointermove', function (e) {
        var r = escena.getBoundingClientRect();
        var x = (e.clientX - r.left) / r.width - 0.5, y = (e.clientY - r.top) / r.height - 0.5;
        marco.style.setProperty('--rx', (-y * 5).toFixed(2) + 'deg');
        marco.style.setProperty('--ry', (x * 7).toFixed(2) + 'deg');
      });
      escena.addEventListener('pointerleave', function () { marco.style.setProperty('--rx', '0deg'); marco.style.setProperty('--ry', '0deg'); });
    }

    var aviso = escena.querySelector('.cti__girar'); if (aviso) aviso.remove();
    var lienzo = escena.querySelector('.cti__lienzo'); if (lienzo) lienzo.remove();

    return {
      objetivo: function (h, w, corte, talla, tipo) {
        if (!activo) return;
        var prenda = tipo === 'polera' ? 'polera' : (PRENDA[corte] || 'clasico');
        var cuerpo = cuerpoDe(h, w);
        mostrar(url(cuerpo, prenda, ancho));
        altura(h);
        // las demás fotos de este cuerpo y las de los cuerpos vecinos, por si mueve la barra
        var i = CUERPOS.map(function (c) { return c[0]; }).indexOf(cuerpo), vecinos = [];
        [i - 1, i, i + 1].forEach(function (k) { if (CUERPOS[k]) (tipo === 'polera' ? ['polera'] : ['clasico', 'oversize']).forEach(function (pr) { vecinos.push(url(CUERPOS[k][0], pr, ancho)); }); });
        precargar(vecinos);
      },
      pausar: function () { activo = false; },
      reanudar: function () { activo = true; },
    };
  }

  if (typeof window !== 'undefined') window.CalacasTallaFotos = { montar: montar, cuerpoDe: cuerpoDe };
  if (typeof module !== 'undefined') module.exports = { cuerpoDe: cuerpoDe };
})();

/* «¿Cuál es mi talla?» — ventana con maniquí 3D (three.js, se carga solo al abrir).
   Botón en la página: <button type="button" data-talla-ideal data-tipo="polo|polera">.
   Al elegir, marca el corte y la talla en el formulario del producto (Producto Calacas y Personalizable). */
(function () {
  'use strict';
  if (typeof document === 'undefined' || window.__tallaIdeal) return;
  window.__tallaIdeal = true;

  var T = window.CalacasTalla;
  var yo = document.currentScript;
  var tipoPagina = (yo && yo.getAttribute('data-tipo')) || 'polo'; // el tema dice si el producto es polera
  var WA = 'https://wa.me/51970519995?text=';
  var menosMov = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var LIM = { h: [140, 200], w: [40, 130] };

  /* ---------- estado ---------- */
  var est = { h: 170, w: 68, corte: 'oversize', tipo: 'polo' };
  try { var g = JSON.parse(localStorage.getItem('calacas-talla') || 'null'); if (g && g.h && g.w) { est.h = g.h; est.w = g.w; } } catch (e) { /* sin almacenamiento */ }
  function guardar() { try { localStorage.setItem('calacas-talla', JSON.stringify({ h: est.h, w: est.w })); } catch (e) { /* nada */ } }

  var dlg, d3 = null, abiertoDesde = null;

  /* ---------- ventana ---------- */
  function crear() {
    dlg = document.createElement('div');
    dlg.className = 'cti';
    dlg.setAttribute('role', 'dialog');
    dlg.setAttribute('aria-modal', 'true');
    dlg.setAttribute('aria-labelledby', 'cti-titulo');
    dlg.hidden = true;
    dlg.innerHTML =
      '<div class="cti__velo" data-cti-cerrar></div>' +
      '<div class="cti__caja">' +
        '<button type="button" class="cti__x" data-cti-cerrar aria-label="Cerrar">×</button>' +
        '<div class="cti__escena">' +
          '<canvas class="cti__lienzo" aria-hidden="true"></canvas>' +
          '<div class="cti__cargando">Cargando…</div>' +
          '<div class="cti__regla" aria-hidden="true"><b data-cti-v="h2">1.70 m</b><span data-cti-v="w2">68 kg</span></div>' +
          '<div class="cti__chip-fit" data-cti-v="fit">Suelto</div>' +
          '<div class="cti__girar" aria-hidden="true">⟲ Arrastra para girar</div>' +
        '</div>' +
        '<div class="cti__panel">' +
          '<p class="cti__kicker">Guía de tallas Calacas</p>' +
          '<h2 class="cti__titulo" id="cti-titulo">¿Cuál es <mark>mi talla</mark>?</h2>' +
          '<p class="cti__sub">Pon tu altura y tu peso: te decimos qué talla te queda mejor.</p>' +
          control('h', 'Altura', 'cm', LIM.h) +
          control('w', 'Peso', 'kg', LIM.w) +
          '<div class="cti__res" data-cti-res role="group" aria-label="Talla recomendada"></div>' +
          '<p class="cti__aviso" data-cti-v="aviso" aria-live="polite"></p>' +
          '<button type="button" class="cti__cta" data-cti-elegir><span data-cti-v="cta">Elegir</span></button>' +
          '<details class="cti__tabla"><summary>Ver medidas de la prenda (cm)</summary><div data-cti-tabla></div></details>' +
          '<a class="cti__wa" data-cti-wa target="_blank" rel="noopener">¿Dudas? Te asesoramos por WhatsApp</a>' +
          '<p class="cti__nota">Es una guía aproximada: cada cuerpo es distinto. Si te gusta más suelto en clásico, pide una talla más.</p>' +
        '</div>' +
      '</div>';
    document.body.appendChild(dlg);

    dlg.addEventListener('click', function (e) {
      if (e.target.closest('[data-cti-cerrar]')) cerrar();
      var paso = e.target.closest('[data-cti-paso]');
      if (paso) { var k = paso.getAttribute('data-cti-paso'), s = +paso.getAttribute('data-d'); fijar(k, est[k] + s); }
      var tarjeta = e.target.closest('[data-cti-corte]');
      if (tarjeta) { est.corte = tarjeta.getAttribute('data-cti-corte'); pintar(); }
      if (e.target.closest('[data-cti-elegir]')) elegir();
    });
    dlg.querySelectorAll('input[type=range]').forEach(function (r) {
      r.addEventListener('input', function () { fijar(r.name, +r.value); });
    });
    dlg.addEventListener('keydown', function (e) {
      if (e.key === 'Escape') { e.preventDefault(); cerrar(); }
      if (e.key === 'Tab') atraparFoco(e);
    });
  }

  function control(k, nombre, unidad, lim) {
    return '<div class="cti__ctrl">' +
      '<div class="cti__ctrl-top"><label for="cti-' + k + '">' + nombre + '</label><b class="cti__num" data-cti-v="' + k + '"></b></div>' +
      '<div class="cti__ctrl-fila">' +
        '<button type="button" class="cti__paso" data-cti-paso="' + k + '" data-d="-1" aria-label="Menos ' + nombre.toLowerCase() + '">−</button>' +
        '<input id="cti-' + k + '" name="' + k + '" type="range" min="' + lim[0] + '" max="' + lim[1] + '" step="1" aria-valuetext="">' +
        '<button type="button" class="cti__paso" data-cti-paso="' + k + '" data-d="1" aria-label="Más ' + nombre.toLowerCase() + '">+</button>' +
      '</div></div>';
  }

  function fijar(k, v) {
    var lim = LIM[k];
    est[k] = Math.max(lim[0], Math.min(lim[1], Math.round(v)));
    guardar(); pintar();
  }

  function cortes() { return est.tipo === 'polera' ? ['polera'] : ['clasico', 'oversize']; }
  var NOMBRE = { clasico: 'Clásico', oversize: 'Oversize', polera: 'Polera' };
  var EXPLICA = { clasico: 'Entallado, tela 30/1 fresca', oversize: 'Amplio, mangas a los codos', polera: 'Con capucha, abrigadora' };

  function pintar() {
    var q = function (s) { return dlg.querySelector(s); };
    var m = (est.h / 100).toFixed(2) + ' m';
    q('[data-cti-v="h"]').textContent = m;
    q('[data-cti-v="w"]').textContent = est.w + ' kg';
    q('[data-cti-v="h2"]').textContent = m;
    q('[data-cti-v="w2"]').textContent = est.w + ' kg';
    var rh = q('#cti-h'), rw = q('#cti-w');
    rh.value = est.h; rw.value = est.w;
    rh.setAttribute('aria-valuetext', m); rw.setAttribute('aria-valuetext', est.w + ' kilos');
    rh.style.setProperty('--p', ((est.h - LIM.h[0]) / (LIM.h[1] - LIM.h[0]) * 100) + '%');
    rw.style.setProperty('--p', ((est.w - LIM.w[0]) / (LIM.w[1] - LIM.w[0]) * 100) + '%');

    var lista = cortes();
    if (lista.indexOf(est.corte) < 0) est.corte = lista[lista.length - 1];
    var res = q('[data-cti-res]'), aviso = '';
    var html = '';
    lista.forEach(function (c) {
      var r = T.recomendar(c, est.h, est.w);
      if (r.aviso) aviso = r.aviso;
      html += '<button type="button" class="cti__card' + (c === est.corte ? ' is-on' : '') + '" data-cti-corte="' + c + '" aria-pressed="' + (c === est.corte) + '">' +
        '<span class="cti__card-corte">' + NOMBRE[c] + '</span>' +
        '<span class="cti__card-talla" data-talla="' + r.talla + '">' + r.talla + '</span>' +
        '<span class="cti__card-fit">' + r.holgura.como + '</span>' +
        '<span class="cti__card-exp">' + EXPLICA[c] + '</span></button>';
    });
    var previo = res.getAttribute('data-firma'), firma = lista.map(function (c) { return T.recomendar(c, est.h, est.w).talla; }).join(',') + est.corte;
    res.innerHTML = html;
    if (previo && previo !== firma && !menosMov) res.querySelectorAll('.cti__card-talla').forEach(function (n) { n.classList.add('is-pop'); });
    res.setAttribute('data-firma', firma);
    q('[data-cti-v="aviso"]').textContent = aviso;

    var act = T.recomendar(est.corte, est.h, est.w);
    q('[data-cti-v="cta"]').textContent = 'Elegir ' + NOMBRE[est.corte] + ' ' + act.talla;
    q('[data-cti-v="fit"]').textContent = NOMBRE[est.corte] + ' ' + act.talla + ' · ' + act.holgura.como;
    q('[data-cti-wa]').href = WA + encodeURIComponent('Hola, mido ' + m + ' y peso ' + est.w + ' kg. ¿Qué talla me recomiendas?');
    tabla();
    if (d3) d3.objetivo(est.h, est.w, est.corte, act.talla, est.tipo);
  }

  function tabla() {
    var cont = dlg.querySelector('[data-cti-tabla]');
    var html = '';
    cortes().forEach(function (c) {
      var rec = T.recomendar(c, est.h, est.w).talla;
      html += '<table><caption>' + NOMBRE[c] + '</caption><thead><tr><th>Talla</th><th>Largo</th><th>Ancho</th><th>Manga</th></tr></thead><tbody>';
      T.ORDEN.forEach(function (t) {
        var md = T.MEDIDAS[c][t];
        html += '<tr' + (t === rec ? ' class="is-rec"' : '') + '><td>' + t + '</td><td>' + md[0] + '</td><td>' + md[1] + '</td><td>' + md[2] + '</td></tr>';
      });
      html += '</tbody></table>';
    });
    cont.innerHTML = html;
  }

  /* ---------- aplicar al producto ---------- */
  function elegir() {
    var r = T.recomendar(est.corte, est.h, est.w);
    var corte = est.corte === 'clasico' ? /cl[aá]sico/i : est.corte === 'oversize' ? /oversize/i : null;
    var ok = marcar(corte, r.talla);
    cerrar();
    if (ok && ok.scrollIntoView) ok.scrollIntoView({ block: 'center', behavior: menosMov ? 'auto' : 'smooth' });
  }

  // Busca en el formulario de la página el botón/radio de la talla y del corte y lo pulsa (sin romper su lógica).
  function marcar(reCorte, talla) {
    var raiz = (abiertoDesde && abiertoDesde.closest('section, .cpp, form')) || document;
    var clic = function (n) { if (n) n.click(); return n; };
    // Personalizable: radios data-ipz-option + label
    var radios = raiz.querySelectorAll('input[data-ipz-option]');
    if (radios.length) {
      var hecho = null;
      radios.forEach(function (r) {
        var v = r.value.trim();
        if ((reCorte && reCorte.test(v) && !/blanco/i.test(v)) || v === talla) hecho = clic(document.querySelector('label[for="' + r.id + '"]')) || hecho;
      });
      return hecho;
    }
    // Producto Calacas: botones .cpp__chip[data-cpp-value]
    var chips = raiz.querySelectorAll('[data-cpp-option][data-cpp-value]');
    var ultimo = null;
    chips.forEach(function (b) {
      var v = b.getAttribute('data-cpp-value').trim();
      if ((reCorte && reCorte.test(v) && !/blanco/i.test(v)) || v === talla) { b.click(); ultimo = b; }
    });
    return ultimo;
  }

  /* ---------- abrir / cerrar ---------- */
  function abrir(boton) {
    if (!dlg) crear();
    abiertoDesde = boton;
    est.tipo = (boton && boton.getAttribute('data-tipo')) || 'polo';
    var corteActual = leerCorteActual(boton);
    if (corteActual) est.corte = corteActual;
    pintar();
    dlg.hidden = false;
    document.documentElement.classList.add('cti-abierto');
    requestAnimationFrame(function () { dlg.classList.add('is-on'); });
    setTimeout(function () { var f = dlg.querySelector('#cti-h'); if (f) f.focus({ preventScroll: true }); }, menosMov ? 0 : 280);
    iniciar3D();
  }

  function leerCorteActual(boton) {
    var raiz = (boton && boton.closest('section, .cpp, form')) || document;
    var sel = raiz.querySelector('input[data-ipz-option]:checked, .cpp__chip.sel');
    var todos = raiz.querySelectorAll('input[data-ipz-option]:checked, .cpp__chip.sel');
    for (var i = 0; i < todos.length; i++) {
      var v = todos[i].value || todos[i].getAttribute('data-cpp-value') || '';
      if (/oversize/i.test(v)) return 'oversize';
      if (/cl[aá]sico/i.test(v)) return 'clasico';
    }
    return sel ? null : null;
  }

  function cerrar() {
    if (!dlg || dlg.hidden) return;
    dlg.classList.remove('is-on');
    document.documentElement.classList.remove('cti-abierto');
    if (d3) d3.pausar();
    setTimeout(function () { dlg.hidden = true; }, menosMov ? 0 : 320);
    if (abiertoDesde) abiertoDesde.focus({ preventScroll: true });
  }

  function atraparFoco(e) {
    var f = [].slice.call(dlg.querySelectorAll('button, input, summary, a[href]')).filter(function (n) { return n.offsetParent !== null; });
    if (!f.length) return;
    if (e.shiftKey && document.activeElement === f[0]) { e.preventDefault(); f[f.length - 1].focus(); }
    else if (!e.shiftKey && document.activeElement === f[f.length - 1]) { e.preventDefault(); f[0].focus(); }
  }

  document.addEventListener('click', function (e) {
    var b = e.target.closest('[data-talla-ideal]');
    if (b) { e.preventDefault(); abrir(b); }
  });

  /* ---------- botón automático junto a «Talla» (en el tema no se tocan las secciones) ---------- */
  var ICONO = '<svg viewBox="0 0 16 16" fill="none" stroke="currentColor" stroke-width="1.6" aria-hidden="true"><path d="M2 11 11 2l3 3-9 9H2z"/><path d="m6 7 1.5 1.5M8 5l1.5 1.5M4 9l1.5 1.5"/></svg>';
  function ponerBotones() {
    // .cpp__opt-label = Producto Calacas · .ipz-step__head = Personalizable
    document.querySelectorAll('.cpp__opt-label, .ipz-step__head').forEach(function (et) {
      if (et.querySelector('[data-talla-ideal]')) return;
      var titulo = et.querySelector('.ipz-step__title') || et;
      var texto = (titulo.textContent || '').replace(/^\s*\d+/, '').trim().toLowerCase();
      if (texto.indexOf('talla') !== 0) return;
      var b = document.createElement('button');
      b.type = 'button'; b.className = 'cti-boton'; b.setAttribute('data-talla-ideal', '');
      b.setAttribute('data-tipo', tipoPagina);
      b.innerHTML = ICONO + '¿Cuál es mi talla?';
      et.appendChild(b);
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', ponerBotones); else ponerBotones();


  /* ---------- 3D (talla-3d.js) ---------- */
  var THREE_ESM = 'https://cdn.jsdelivr.net/npm/three@0.170.0/+esm';
  var GLTF_ESM = 'https://cdn.jsdelivr.net/npm/three@0.170.0/examples/jsm/loaders/GLTFLoader.js/+esm';

  // Shopify minifica los assets y cambia import() por require() (no existe en el navegador):
  // por eso el módulo se pide con un <script type="module"> que deja el resultado en window.
  var modulos = {};
  function cargarModulo(url) {
    if (modulos[url]) return modulos[url];
    modulos[url] = new Promise(function (ok, mal) {
      var clave = '__cti' + Object.keys(modulos).length;
      var s = document.createElement('script');
      s.type = 'module';
      s.textContent = 'import * as m from ' + JSON.stringify(url) + '; window[' + JSON.stringify(clave) + '] = m; window.dispatchEvent(new Event(' + JSON.stringify(clave) + '));';
      var tiempo = setTimeout(function () { mal(new Error('sin respuesta: ' + url)); }, 20000);
      window.addEventListener(clave, function () { clearTimeout(tiempo); ok(window[clave]); }, { once: true });
      s.onerror = function () { clearTimeout(tiempo); mal(new Error('no cargó: ' + url)); };
      document.head.appendChild(s);
    });
    return modulos[url];
  }

  function iniciar3D() {
    var talla = T.recomendar(est.corte, est.h, est.w).talla;
    if (d3) { d3.reanudar(); d3.objetivo(est.h, est.w, est.corte, talla, est.tipo); return; }
    var escena = dlg.querySelector('.cti__escena');
    var lienzo = dlg.querySelector('.cti__lienzo');
    // fotos reales (preferidas): no bajan three.js ni el modelo
    if (window.CalacasTallaFotos) {
      d3 = window.CalacasTallaFotos.montar(T, escena, { menosMov: menosMov });
      d3.objetivo(est.h, est.w, est.corte, talla, est.tipo);
      return;
    }
    var D = window.CalacasTalla3D;
    var probar = document.createElement('canvas');
    if (!D || !(probar.getContext('webgl2') || probar.getContext('webgl'))) { escena.classList.add('sin-3d'); return; }
    d3 = { objetivo: function () {}, pausar: function () {}, reanudar: function () {} }; // marcador mientras carga
    // el modelo (≈3 MB) se baja en paralelo con three.js
    var modelo = fetch(D.MODELO).then(function (r) { if (!r.ok) throw new Error('modelo ' + r.status); return r.arrayBuffer(); });
    Promise.all([cargarModulo(THREE_ESM), cargarModulo(GLTF_ESM), modelo]).then(function (res) {
      var THREE = res[0], Cargador = res[1].GLTFLoader;
      return new Promise(function (ok, mal) { new Cargador().parse(res[2], '', ok, mal); }).then(function (gltf) {
        d3 = D.montar(THREE, gltf, T, escena, lienzo, { menosMov: menosMov, tipo: est.tipo, h: est.h, w: est.w });
        escena.classList.add('listo');
        d3.objetivo(est.h, est.w, est.corte, T.recomendar(est.corte, est.h, est.w).talla, est.tipo);
        if (dlg.hidden) d3.pausar(); // se cerró mientras cargaba
      });
    }).catch(function (err) {
      console.warn('[talla] sin 3D', err);
      escena.classList.add('sin-3d');
      d3 = null;
    });
  }
})();
